import auth from "./auth";
import i18next from "i18next";
// 封装自定义的网络请求
const http = {
  fetch: (url, options = {}) => {
    const defaultHeaders = {
      token: auth.getToken(),
      lang: i18next.language,
    };

    const headers = options.headers ? { ...options.headers, ...defaultHeaders } : defaultHeaders;

    return fetch(url, { ...options, headers });
  },
};

export default http;
